import _defineProperty from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import { createLoader } from '@spotify-internal/creator-data-loading';
import { fetchEntryList } from '../Contentful';
import { itemToSearchHit } from './content';
var searchLoaderContentful = createLoader( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
    var _query$limit, limit, _query$skip, skip, contentTypes, uid, q, language, params, resp;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _query$limit = query.limit, limit = _query$limit === void 0 ? 10 : _query$limit, _query$skip = query.skip, skip = _query$skip === void 0 ? 0 : _query$skip, contentTypes = query.contentTypes, uid = query.uid;
            q = query.query;
            language = query.locale || 'en-US';

            if ((contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.length) === 1 && (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes[0]) === 'faq') {
              params = {
                contentType: 'faq',
                limit: limit,
                skip: skip,
                locale: language,
                filters: {
                  'indexed[nin]': false,
                  'question[exists]': true,
                  'answer[exists]': true
                },
                select: ['fields.question', 'fields.urlSlug'],
                query: q
              };
            } else {
              params = {
                limit: limit,
                skip: skip,
                query: q
              };
            }

            _context.prev = 4;
            _context.next = 7;
            return fetchEntryList(params);

          case 7:
            resp = _context.sent;
            return _context.abrupt("return", {
              uid: uid,
              hits: resp.entries.map(function (item) {
                return itemToSearchHit(item);
              }).filter(Boolean).map(function (hit) {
                return _objectSpread(_objectSpread({}, hit), {}, {
                  searchUid: uid
                });
              }),
              limit: resp.limit,
              skip: resp.skip,
              query: q,
              total: resp.total
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", {
              uid: uid,
              hits: [],
              total: 0,
              limit: 0,
              skip: 0,
              query: q,
              error: _context.t0.message
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), {
  cacheKeyFn: JSON.stringify
});
export function getSearchLoader() {
  return searchLoaderContentful;
}
var searchLoader = searchLoaderContentful;
export { searchLoader };